import randomColor from "randomcolor";

export const getRandomBorderColor = (): string => {
  return randomColor({
    luminosity: "dark",
  });
};